// Start warstwy językowej — PRZED pierwszym renderem Reacta (main.tsx czeka na tę
// obietnicę), żeby przy EN nie mignęła wersja polska. Słownik to osobny plik .json
// z hashem w nazwie (`?url` — asset, nie chunk JS: ~575 kB jako moduł przekraczało próg
// ostrzeżenia Vite, a JSON.parse jest szybszy od parsowania literału w JS); użytkownik PL
// go w ogóle nie ściąga.
import { LANG } from './lang'
import dictUrl from './en.json?url'
import structureUrl from './structure.json?url'
import { makeTranslator } from './translate'
import { startDomTranslator } from './dom'

export async function initI18n(): Promise<void> {
  document.documentElement.lang = LANG
  if (LANG !== 'en') return
  try {
    const load = async <T,>(url: string): Promise<T> => {
      const res = await fetch(url)
      if (!res.ok) throw new Error(`${url}: ${res.status}`)
      return res.json() as Promise<T>
    }
    const [dict, structure] = await Promise.all([load<Record<string, string>>(dictUrl), load<string[]>(structureUrl)])
    const t = makeTranslator(dict, structure)
    startDomTranslator(t)
    // Okna przeglądarki (confirm/alert/prompt) nie są w DOM-ie — tłumaczymy ich treść.
    const tr = (m: unknown) => (typeof m === 'string' ? t.translate(m) ?? m : m)
    const { alert, confirm, prompt } = window
    window.alert = (m?: unknown) => alert.call(window, tr(m))
    window.confirm = (m?: string) => confirm.call(window, tr(m) as string)
    window.prompt = (m?: string, d?: string) => prompt.call(window, tr(m) as string, d)
    ;(window as unknown as { __i18n: unknown }).__i18n = t
  } catch (e) {
    console.error('i18n: słownik EN nie wczytał się — zostaje PL', e)
  }
}
